import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'valueChecker'
})
export class ValueCheckerPipe implements PipeTransform {

  transform(value: string): string {
    return value ? value : '-';
  }
}
